import { constants, typographyStyles } from "@newsela/angelou";
const { colors } = constants;
const { heading4Obj } = typographyStyles;

const darkBlack = colors.ui.black[700];
const neutral500 = colors.ui.neutral[500];

// Styles for indiviual activity panels

export const centered = {
  display: "flex",
  flexDirection: "column" as const,
  alignItems: "center" as const,
  justifyContent: "center" as const,
};

export const completedWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  position: "relative" as const,
  alignItems: "center" as const,
  justifyContent: "center" as const,
  width: "100%",
  padding: "24px",
};

export const completeHeaderImage = {
  position: "absolute" as const,
  top: "0px",
  width: "100%",
  zIndex: "99" as const,
};

export const completeIcon = {
  width: "100%",
  maxWidth: "180px",
  height: "100%",
  maxHeight: "180px",
  margin: "0 auto",
};

export const rewardWrapper = {
  display: "flex",
  flexDirection: "row" as const,
  position: "relative" as const,
  alignItems: "center" as const,
  justifyContent: "center" as const,
  padding: "24px",
};

export const floatingText = (shouldShowTokens: boolean) => ({
  position: "absolute" as const,
  top: shouldShowTokens ? "-75px" : "-60px",
  right: shouldShowTokens ? "60px" : "0px",
  zIndex: "99",
  fontSize: shouldShowTokens ? "24px" : "30px",
  fontWeight: "700",
  color: shouldShowTokens ? "#17786C" : "white",
  backgroundColor: shouldShowTokens ? "white" : neutral500,
  padding: "8px",
  borderRadius: "8px",
  width: shouldShowTokens ? "85px" : "100px",
});

export const rewardIconCss = {
  width: "61px",
  height: "61px",
  top: "-50px",
  right: "20px",
  zIndex: "98",
  position: "absolute" as const,
  color: "#17786C",
};

export const textCompleteCss = {
  margin: 0,
  ...heading4Obj,
  color: darkBlack,
  fontWeight: "700",
  marginRight: "50px",
};
